import Login from "../../allauth/account/Login";

export default function LoginScreen() {

    return (
            <Login/>
    )
}
